import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectorCoreConfirmPasswordFailed } from '../../core.reducer';

@Component({
  selector: 'bepatient-confirm-password-popup',
  templateUrl: './confirm-password-popup.component.html',
  styleUrls: ['./confirm-password-popup.component.scss'],
  standalone: false
})
export class ConfirmPasswordPopupComponent {
  private store = inject<Store<any>>(Store);

  @Input() color: string;
  @Output() validated = new EventEmitter<string>();

  confirmPasswordFailed$: Observable<boolean>;
  passwordForm: UntypedFormGroup;
  viewPasswordIcon = 'eye';
  viewPasswordType = 'password';

  constructor() {
    this.confirmPasswordFailed$ = this.store.pipe(
      select(selectorCoreConfirmPasswordFailed)
    );
    this.passwordForm = new UntypedFormGroup({
      password: new UntypedFormControl()
    });
  }

  viewPassword(): void {
    this.viewPasswordType =
      this.viewPasswordType === 'text' ? 'password' : 'text';
    this.viewPasswordIcon =
      this.viewPasswordIcon === 'eye-off' ? 'eye' : 'eye-off';
  }
}
